const FOCUSABLE = 'input, select, textarea, button, [tabindex]';

/**
 * Scrolls the first visible field showing an error into view and focuses its control. Fields mark
 * themselves with data-field-error; responsive layouts render some fields twice, one copy hidden, so
 * a marked element without an offsetParent (display: none) is skipped when a visible one exists.
 */
export function scrollToFirstError(): void {
  const marked = Array.from(document.querySelectorAll<HTMLElement>('[data-field-error="true"]'));
  const target = marked.find(element => element.offsetParent !== null) ?? marked[0];
  if (!target) return;
  target.scrollIntoView?.({ block: 'center', behavior: 'smooth' });
  const control = target.matches(FOCUSABLE) ? target : target.querySelector<HTMLElement>(FOCUSABLE);
  control?.focus?.({ preventScroll: true });
}

export default scrollToFirstError;
